// MARK://dhk8/pos/hooks/useFloorAlertsCount
// Conteo VIVO de AVISOS del comensal pendientes (guest notifications en estado
// PENDING) para la "bolita" roja de la nav "Avisos" — misma UX que la de
// "Entrantes" (usePendingAcceptanceCount). El WS del canal `t:{tid}:notifications`
// dispara un refetch del conteo autoritativo por REST; fallback poll lento 60s.
import { useCallback, useEffect, useRef, useState } from 'react'
import { useRealtimeSubscription } from '@dockethub/realtime'
import { listGuestNotifications } from '../lib/clients/floor.js'
import { useAuthStore } from '../stores/auth-store.js'

const POLL_FALLBACK_MS = 60_000
const DEBOUNCE_MS = 400

export function useFloorAlertsCount(): number {
  const tenantId = useAuthStore((s) => s.activeTenantId())
  const branchId = useAuthStore((s) => s.user?.branchId)
  const [count, setCount] = useState(0)
  const debounce = useRef<ReturnType<typeof setTimeout> | null>(null)

  const refetch = useCallback(async () => {
    if (tenantId === null) { setCount(0); return }
    try {
      // Sólo la sucursal activa del staff (la nav es de esta terminal).
      const r = await listGuestNotifications({ status: 'PENDING', ...(branchId ? { branchId } : {}), limit: 100 })
      setCount(r.total ?? r.items.length)
    } catch {
      /* deja el último conteo — no romper la nav por un fallo de red */
    }
  }, [tenantId, branchId])

  const bump = useCallback(() => {
    if (debounce.current !== null) clearTimeout(debounce.current)
    debounce.current = setTimeout(() => { void refetch() }, DEBOUNCE_MS)
  }, [refetch])

  useEffect(() => {
    void refetch()
    const poll = setInterval(() => { void refetch() }, POLL_FALLBACK_MS)
    return () => {
      clearInterval(poll)
      if (debounce.current !== null) clearTimeout(debounce.current)
    }
  }, [refetch])

  useRealtimeSubscription(tenantId !== null ? `t:${tenantId}:notifications` : '', bump, [tenantId])

  return count
}
